import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.contact.update;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'CONTACT_UPDATE',
	method: 'POST',
	url: '/contact/update.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
